import React, { useMemo } from 'react';
import classes from './ExpireAfterDate.module.scss';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { CalendarPicker } from '../../../../components/actions/CalendarPicker';
import { useSettings } from '../../../../hooks/useSettings';
import { convertDateFormatSettingToString } from '../../../../helpers/timeFormatter';
import { FormElementAction } from '../../../../models/basic-objects';
import classNames from 'classnames';
import { Tooltip } from '../../../../components/actions/Tooltip';
import { idGenerator } from '../../../../helpers/idGenerator';
import scssVars from '../../../../assets/scss/exportedVars.module.scss';
export type ExpireAfterDateViewProps = {
  //
  formInstance: UseFormReturn;
  calendarUpdateAction: FormElementAction<Date>;
  name: string;
  disabled?: boolean;
  date?: Date;
  isError?: string;
  isWarning?: string;
  minDate?: Date;
};

export const ExpireAfterDateView = ({
  formInstance,
  name,
  disabled,
  date,
  isError,
  isWarning,
  calendarUpdateAction,
  minDate
}: ExpireAfterDateViewProps): JSX.Element => {
  const rules: RegisterOptions = {};

  const id = useMemo(() => idGenerator(`expireAfterDate`), []);
  const { selectedOrgSettings } = useSettings();
  const { dateFormat: rawDate } = selectedOrgSettings ?? {};
  if (!rawDate) throw new Error('rawDate is undefined');
  const dateFormat = convertDateFormatSettingToString(rawDate);
  minDate = minDate || new Date();
  return (
    <div data-testid={'ExpireAfter'} className={'grid-x align-middle'}>
      <div className={`cell shrink ${classes.ExpireAfterDate}`}>
        <div
          className={classNames(
            classes.ExpireAfterDateCell,
            isWarning && classes.WarningClass,
            isError && classes.ErrorClass
          )}>
          <CalendarPicker
            updateAction={calendarUpdateAction}
            placeholder={'Select date'}
            name={name}
            useFormInstance={formInstance}
            inputSize={'large'}
            rules={rules}
            calendarProps={{
              dateFormat,
              minDate
            }}
            {...(disabled ? { disabled: true } : {})}
            {...(date ? { date } : {})}
            startDay={selectedOrgSettings?.startOfWeekFormat}
            isError={!disabled ? isError : undefined}
            isWarning={!disabled ? isWarning : undefined}
          />
        </div>
      </div>
      {(isError || isWarning) && !disabled ? (
        <div className={classNames('cell', 'shrink', classes.ExpireAfterCountTooltip)}>
          <Tooltip
            icon={isError ? 'alert' : 'warning'}
            target={`#${id}`}
            position={'right'}
            pointer={true}
            type={'inlined'}
            autoZIndex={false}
            style={{ zIndex: scssVars['z-index-overmodal'] }}>
            <>{isError || isWarning}</>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
};
